import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export const AuthShell = ({ eyebrow, title, subtitle, children, footer }) => (
  <div className="min-h-screen grid lg:grid-cols-[1fr_1.1fr] bg-paper">
    <aside className="relative hidden lg:flex flex-col justify-between overflow-hidden bg-navy p-12 text-white">
      <img src="/images/desk.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-gradient-to-b from-navy/70 to-navy" />
      <div className="relative"><Logo light /></div>
      <div className="relative max-w-md">
        <div className="h-px w-16 bg-gold mb-6" />
        <p className="font-display text-3xl font-semibold leading-snug">Know what your paperwork asks of you, and when.</p>
        <p className="mt-4 text-white/70">Keep documents private, list the next steps, and track the due dates you've confirmed.</p>
      </div>
      <p className="relative text-xs text-white/50">Your files are only visible to members of your workspace.</p>
    </aside>
    <main className="flex flex-col px-5 py-8 sm:px-10">
      <div className="lg:hidden mb-10"><Logo /></div>
      <div className="mx-auto my-auto w-full max-w-md fade-up">
        {eyebrow && <p className="eyebrow text-gold-dark">{eyebrow}</p>}
        <h1 className="mt-2 text-3xl sm:text-4xl font-bold tracking-tight text-navy">{title}</h1>
        {subtitle && <p className="mt-3 text-slate-600 leading-relaxed">{subtitle}</p>}
        <div className="mt-8">{children}</div>
        {footer && <div className="mt-8 text-sm text-slate-600">{footer}</div>}
      </div>
      <Link to="/" data-testid="auth-back-home-link" className="mx-auto mt-10 text-xs text-slate-500 hover:text-navy">Back to home</Link>
    </main>
  </div>
);

export const FormError = ({ message, testId = "form-error" }) =>
  message ? (
    <div data-testid={testId} role="alert" className="rounded-md border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800">{message}</div>
  ) : null;
